export const _LOAD_MODEL_ = 'Load:Comment';
export const _SAVE_MODEL_ = 'Save:Comment';
export const _DELETE_COMMENT_ = 'Delete:Comment';

export const MODEL = {
  id: null,
  status: '',
  comment: '',
  user_id: null,
  parent_id: null,
  puzzle_id: null,
};
